'use strict';

const { CLASSES } = require('../utils/globals');
const SELECTORS = {
    body: 'body',
    search: '.js-header-search',
    searchToggleBtn: '.js-search-toggle-btn',
    searchResetBtn: '.js-search-reset-button',
    searchInput: '.js-search-input',
    suggestions: '.js-suggestions',
    suggestionsWrapper: '.js-suggestions-wrapper',
};

const debounce = require('lodash/debounce');
const endpoint = $(SELECTORS.suggestionsWrapper).data('url');
const minChars = 3;

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $(SELECTORS.searchInput).val('');
    $(SELECTORS.suggestionsWrapper).empty();
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = $(SELECTORS.suggestionsWrapper).empty();

    $.spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .suggestions-item');
        if ($(suggestionsList).length) {
            $('input.search-field')
                .attr('aria-describedby', 'search-result-count')
                .attr('aria-expanded', 'true');
        } else {
            $('input.search-field').removeAttr('aria-describedby')
                .attr('aria-expanded', 'false');
        }
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        $(scope).siblings('.reset-button').removeClass('d-sm-block');
        $(SELECTORS.suggestionsWrapper).empty();
    }
}

/**
 * Init search events
 *
 */
function initEvents() {
    $('form[name="simpleSearch"]').on('submit', function (e) {
        var suggestionsList = $('.suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $(SELECTORS.searchInput).each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        let debounceSuggestions = debounce(getSuggestions, 300);
        const $this = $(this);

        $this.on('keyup', function (e) {
            if ($this.parents().hasClass('search-mobile')) {
                return;
            }

            if (e.key !== 'Enter') {
                debounceSuggestions(this, e);
            }

            // accessibility to return back to the search button focus.
            if (e.key == 'Escape') {
                $(SELECTORS.searchToggleBtn).trigger('click');
                $(SELECTORS.searchToggleBtn).trigger('focus');
            }
        });
    });

    $(SELECTORS.body).on('click', function (e) {
        if (!$(SELECTORS.suggestions).has(e.target).length && !$(e.target).hasClass('search-field')) {
            $(SELECTORS.suggestions).hide();
        }
    });

    $(SELECTORS.body).on('click touchend keydown', SELECTORS.searchToggleBtn, function (e) {
        // accessibility to access search using space or enter.
        if (e.key && (e.key != 'Enter' && e.key != ' ')) {
            return;
        }

        e.preventDefault();
        $(SELECTORS.search).toggleClass(CLASSES.active);

        if ($(SELECTORS.search).hasClass(CLASSES.active)) {
            setTimeout(() => {
                $(SELECTORS.search).find(SELECTORS.searchInput).focus();
            }, 100);
        }

        $(SELECTORS.suggestions).hide();
        tearDownSuggestions();
    });

    $(SELECTORS.body).on('click', SELECTORS.searchResetBtn, function () {
        $(SELECTORS.search).removeClass(CLASSES.active);
    });

    $(SELECTORS.body).on('click', function(event) {
        let closeSearch = !$(event.target).closest(SELECTORS.searchToggleBtn).length && !$(event.target).closest(SELECTORS.search).length
            && $(SELECTORS.search).hasClass(CLASSES.active);

        if (closeSearch) {
            $(SELECTORS.search).removeClass(CLASSES.active);
            $(SELECTORS.searchToggleBtn).trigger('focus');
        }
    });
}

module.exports = {
    initEvents: initEvents
};
